module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("The Joy Fit Club")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "para-style-override-1",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/9781118181393-ftoc01.png"
    }
  })]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/03_9781118181393flast"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/04_9781118181393cmp01#a1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/04_9781118181393cmp01#a2"
    }
  }, [_vm._v("Joy’s Winning Weight Loss Rules")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/05_9781118181393cmp02"
    }
  }, [_vm._v("Joy's Fit Superstars")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/20_9781118181393cmp17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy's 3-Week Meal Plan")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/21_9781118181393cmp18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus Recipes from Joy's Kitchen")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0